export const DocumentosActionTypes = {
  API_RESPONSE_SUCCESS: '@@documentos/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@documentos/API_RESPONSE_ERROR',

  GET_DOCUMENTO: '@@documentos/GET_DOCUMENTO',
  GET_DOCUMENTO_PREVIEW: '@@documentos/GET_DOCUMENTO_PREVIEW',
  LIST_DOCUMENTOS: '@@documentos/LIST_DOCUMENTOS',
  LIST_DOCUMENTOS_PREVIEW: '@@documentos/LIST_DOCUMENTOS_PREVIEW',
  ADD_DOCUMENTO: '@@documentos/ADD_DOCUMENTO',
  UPDATE_DOCUMENTO: '@@documentos/UPDATE_DOCUMENTO',
  DELETE_DOCUMENTO: '@@documentos/DELETE_DOCUMENTO',
  SET_FILTER: '@@documentos/SET_FILTER',

  RESET: '@@documentos/RESET'
}
